 <!-- ===== DRAGGABLE BOXES ===== -->
 <div class="draggable-modals">
    <!-- Loop and add Draggable Boxes below -->
    <ng-container *ngFor="let box of draggableBoxes;let i = index;">
      <div class="draggable-modal resizeable-modal" cdkDrag cdkDragBoundary=".draggable-modal-boundary"
         [ngStyle]="{
         'width': box.width, 'min-width': box.minWidth||'auto', 'height': box.height,
         'top': '5%', 'left': (i+1.15)*10+'%', 'z-index': box.zIndex
         }"
         (click)="bringDraggableBoxToTop(i)"
         *ngIf="box.open && !box.minimized">
        <div class="draggable-modal-handle-container is-draggable" cdkDragHandle>
          <h4 *ngIf="box.title" class="d-b-head">{{box.title}}</h4>
          <div class="draggable-modal-handle-controls">
            <!-- Drag -->
            <span class="d-b-button d-b-handle is-draggable" >
              <i nz-icon nzType="drag"></i>
              <!--<svg width="24px" fill="currentColor" viewBox="0 0 24 24"><path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>-->
            </span>
            <!-- Close -->
            <span class="d-b-button" (click)="box.open=false;deleteBox(i);">
              <i nz-icon nzType="close"></i>
            </span>
            <!-- Minimize -->
            <span class="d-b-button" (click)="box.minimized=true;box.open=false;">
              <i nz-icon nzType="minus"></i>
            </span>
          </div>
        </div>
        <div class="draggable-modal-content">
          <!-- ============ Place DYNAMIC CONTENT here ============ -->
            <!-- <p>Draggable popup content</p> -->
          <app-view-policy-summary [IO]="_payloadInEdit" *ngIf="box.type=='policy-summary'"></app-view-policy-summary>
          <!-- <app-medical-risk [IO]="policyData" *ngIf="box.type=='medical-risk'" [transactionState]="_state" [RequirementEntityGuid]="RequirementEntityGuid"></app-medical-risk> -->

          <!-- ============ /DYNAMIC CONTENT  ============ -->
        </div>
      </div>
    </ng-container>
    <!-- Minimized state for Draggable Boxes -->
    <div class="draggable-modals-minimized">
      <ng-container *ngFor="let box of draggableBoxes;let i = index;">
        <div class="draggable-modal-min clickable" *ngIf="box.minimized && !box.open" (click)="box.open=true;box.minimized=false;" [ngStyle]="{'order':(i+1)}">
          <span class="draggable-modal-min-text txt-ovf-ellipsis">{{box.title}}</span>
          <div>
            <i nz-icon nzType="arrows-alt"></i>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <!-- ===== END DRAGGABLE BOXES ===== -->